import React from "react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Logo from "shared/Logo/Logo";
import { Disclosure } from "@headlessui/react";
import { Link } from "react-router-dom";
import { NavItemType } from "./NavigationItem";
import { NAVIGATION_DEMO } from "data/navigation";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { ChevronDownIcon } from "@heroicons/react/solid";
import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import Avatar from "shared/Avatar/Avatar";
// import Notification from "shared/Notification";
// import Cart from "shared/Cart";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";
import { userLogout } from "actions/userActions";

export interface NavMobileProps {
  data?: NavItemType[];
  onClickClose?: () => void;
}

const NavMobile: React.FC<NavMobileProps> = ({
  data = NAVIGATION_DEMO,
  onClickClose,
}) => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  // const { cartItem } = useSelector((state: RootState) => state.cart);

  const handleLogout = () => {
    dispatch(userLogout());
  };

  const _renderMenuChild = (item: NavItemType) => {
    return (
      <ul className="nav-mobile-sub-menu pl-6 pb-1 text-base">
        {item.children?.map((i, index) => (
          <Disclosure key={i.href + index} as="li">
            <Link
              to={i.href}
              className="flex px-4 py-2.5 text-neutral-900 dark:text-neutral-200 text-sm font-medium rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 mt-[2px]"
            >
              <span
                className={!i.children ? "block w-full" : ""}
                onClick={onClickClose}
              >
                {i.name}
              </span>
              {i.children && (
                <span
                  className="block flex-grow"
                  onClick={(e) => e.preventDefault()}
                >
                  <Disclosure.Button
                    as="span"
                    className="flex justify-end flex-grow"
                  >
                    <ChevronDownIcon
                      className="ml-2 h-4 w-4 text-neutral-500"
                      aria-hidden="true"
                    />
                  </Disclosure.Button>
                </span>
              )}
            </Link>
            {i.children && (
              <Disclosure.Panel>{_renderMenuChild(i)}</Disclosure.Panel>
            )}
          </Disclosure>
        ))}
      </ul>
    );
  };

  const _renderItem = (item: NavItemType, index: number) => {
    return (
      <Disclosure
        key={item.id}
        as="li"
        className="text-neutral-900 dark:text-white"
      >
        <Link
          className="flex w-full items-center py-2.5 px-4 font-medium uppercase tracking-wide text-sm hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg"
          to={item.href}
        >
          <span
            className={!item.children ? "block w-full" : ""}
            onClick={onClickClose}
          >
            {item.name}
          </span>
          {item.children && (
            <span
              className="block flex-grow"
              onClick={(e) => e.preventDefault()}
            >
              <Disclosure.Button
                as="span"
                className="flex justify-end flex-grow"
              >
                <ChevronDownIcon
                  className="ml-2 h-4 w-4 text-neutral-500"
                  aria-hidden="true"
                />
              </Disclosure.Button>
            </span>
          )}
        </Link>
        {item.children && (
          <Disclosure.Panel>{_renderMenuChild(item)}</Disclosure.Panel>
        )}
      </Disclosure>
    );
  };

  return (
    <div className="overflow-y-auto w-full max-w-sm h-screen py-2 transition transform shadow-lg ring-1 dark:ring-neutral-700 bg-white dark:bg-neutral-900 divide-y-2 divide-neutral-100 dark:divide-neutral-800">
      <div className="py-6 px-5">
        <Logo handleClick={onClickClose} />

        <div className="flex flex-col mt-5 text-neutral-700 dark:text-neutral-300 text-sm">
          <span>
            Rentrips ada untuk memenuhi segala kebutuhan perjalanan anda
          </span>

          <div className="flex justify-between items-center mt-4">
            {/* {userInfo && (
              <div className="flex">
                <Notification isMobile={true} />
                <Cart isMobile={true} data={cartItem ? cartItem : []} />
              </div>
            )} */}

            <span className="block">
              <SwitchDarkMode className="bg-neutral-100 dark:bg-neutral-800" />
            </span>
          </div>
        </div>
        <span className="absolute right-2 top-2 p-1">
          <ButtonClose onClick={onClickClose} />
        </span>
      </div>

      <ul className="flex flex-col py-6 px-2 space-y-1">
        {userInfo && (
          <Link
            className="flex items-center text-neutral-700 dark:text-neutral-300 text-sm px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg"
            to="/account"
            onClick={onClickClose}
          >
            <Avatar sizeClass={"w-10 h-10 mr-3"} />
            <p>{userInfo.name}</p>
          </Link>
        )}
        {data.map(_renderItem)}
      </ul>
      {userInfo ? (
        <div className="flex items-center justify-between py-6 px-5 space-x-4">
          <Link to="/login" rel="noopener noreferrer" onClick={handleLogout}>
            <ButtonPrimary>Logout</ButtonPrimary>
          </Link>
        </div>
      ) : (
        <div className="flex items-center justify-between py-6 px-5 space-x-4">
          <Link to="/login" rel="noopener noreferrer">
            <ButtonPrimary onClick={onClickClose}>Login</ButtonPrimary>
          </Link>
        </div>
      )}
    </div>
  );
};

export default NavMobile;
